export default __webpack_public_path__ + "static/media/monkey-2.10eeb101.png";